<template>
	<div class="agreement_page">
		<div class="agreement_title">{{info.title}}</div>
		<div class="agreement_content" v-html="info.content"></div>
		
		<!-- <div style="text-align:center;">
			<h1>富士范儿小程序隐私协议</h1>
		</div>
		<form><div class="group-infos"><p>本指引是富士范儿小程序开发者 "北京御城铭翼网络科技有限公司"（以下简称“开发者”）为处理你的个人信息而制定。</p></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">开发者处理的信息</h5><p class="group-infos__hd-privacyText">根据法律规定，开发者仅处理实现小程序功能所必要的信息。</p></div><ul class="privacy-config__list"><p>
			为了显示真实用户评论，开发者将在获取你的明示同意后，收集你的微信昵称、头像。
			</p><p>
				为了显示信息更准确，开发者将在获取你的明示同意后，收集你的位置信息。
				</p><p>
					为了便于保存图片，开发者将在获取你的明示同意后，使用你的相册（仅写入）权限。
					</p><p>
						为了登录或者注册，开发者将在获取你的明示同意后，收集你的手机号。
						</p><p>
							开发者 收集你选中的照片或视频信息，用于信息展示。
						</p></ul></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">第三方插件信息/SDK信息</h5><p class="group-infos__hd-privacyText">为实现特定功能，开发者可能会接入由第三方提供的插件/SDK。第三方插件/SDK的个人信息处理规则，请以其公示的官方说明为准。富士范儿小程序接入的第三方插件信息/SDK信息如下：</p></div><div style="margin-top: 16px;"><p>插件名称：企业客户服务</p><p>插件提供方名称: 深圳市腾讯计算机系统有限公司</p><ul></ul></div></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">你的权益</h5><p class="group-infos__hd-privacyText"></p></div><p class="group-infos_order">关于收集你的位置信息、使用你的相册（仅写入）权限，你可以通过以下路径：小程序主页右上角“…”—“设置”—点击特定信息—点击“不允许”，撤回对开发者的授权。</p><p class="group-infos_order">关于收集你的手机号、收集你选中的照片或视频信息，你可以通过以下路径：小程序主页右上角“...” — “设置” — “小程序已获取的信息” — 点击特定信息 — 点击“通知开发者删除”，开发者承诺收到通知后将删除信息。</p><p class="group-infos_order">关于你的个人信息，你可以通过以下方式与开发者联系，行使查阅、复制、更正、删除等法定权利。</p><p class="group-infos_order">若你在小程序中注册了账号，你可以通过以下方式与开发者联系，申请注销你在小程序中使用的账号。在受理你的申请后，开发者承诺在十五个工作日内完成核查和处理，并按照法律法规要求处理你的相关信息。</p><ul><p><span>邮箱:</span><span style="overflow: hidden; word-break: break-all;">kefu@motortime.com</span></p></ul></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">开发者对信息的存储</h5><p class="group-infos__hd-privacyText"></p></div><p class="group-infos_order">
						开发者承诺，除法律法规另有规定外，开发者对你的信息的保存期限应当为实现处理目的所必要的最短时间。</p></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">信息的使用规则</h5><p class="group-infos__hd-privacyText"></p></div><p class="group-infos_order">开发者将会在本指引所明示的用途内使用收集的信息</p><p><span class="privacyLabel group-infos_order">如开发者使用你的信息超出本指引目的或合理范围，开发者必须在变更使用目的或范围前，再次以</span><span>消息通知</span><span class="privacyLabel">方式告知并征得你的明示同意。</span></p></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">信息对外提供</h5><p class="group-infos__hd-privacyText"></p></div><p class="group-infos_order">开发者承诺，不会主动共享或转让你的信息至任何第三方，如存在确需共享或转让时，开发者应当直接征得或确认第三方征得你的单独同意。</p><p class="group-infos_order">开发者承诺，不会对外公开披露你的信息，如必须公开披露时，开发者应当向你告知公开披露的目的、披露信息的类型及可能涉及的信息，并征得你的单独同意。</p></div><div class="group-infos"><div class="group-infos__hd"><h5 class="group-infos__title">你认为开发者未遵守上述约定，或有其他的投诉建议、或未成年人个人信息保护相关问题，可通过以下方式与开发者联系；或者向微信进行投诉。</h5><p class="group-infos__hd-privacyText"></p></div><ul><p><span>邮箱 : </span><span style="overflow: hidden; word-break: break-all;">kefu@motortime.com</span></p></ul></div><p class="signature"></p><p class="signature"></p></form> -->
					</div>
				</template>
				<script>
					import content from '../../api/content';
					export default {
						data () {
							return {
								info:'',
							}
						},
						created () {
							this.$store.commit('param/show', false)

							var apppar={
								title:this.$route.meta.title
							}
							this.$appService.changeTitle(apppar)
							this.getAgreement(9)
						},
						methods: {
							getAgreement(id){
								content.getAgreement({id:id}).then(res => {
									this.info=res.data.data
								})
							},
						}
					};
				</script>
				<style lang="scss">
					.agreement_page {
						padding: 10px;
					}
				</style>